<template>
    <el-tooltip :content="desc" effect="light" :open-delay="300" placement="top" v-if="!hidden">
            <span class="badge-danger badge mx-1 custom"
                v-if="!small"
                v-bind:class="{
                    'badge-danger': percent<0, 
                    'badge-success': percent>=0, 
                    'super': percentdiff > 0 }">
                {{this.period}}
                <i v-if="percentdiff > 0">🚀</i>
            </span>
            <span class="smalldot"
                v-if="small"
                v-bind:class="{
                    'danger': percent<0, 
                    'success': percent>=0, 
                    'super': percentdiff > 0 }">
            </span>
    </el-tooltip>
</template>
<script>
export default {
    props: {
        previous: {
            type: Number,
            default: 0
        },
        last: {
            type: Number,
            default: 0
        },
        small: {
            type: Boolean,
            default: false
        },
        hidden: {
            type: Boolean,
            default: false
        },
        period: {
            string: String,
            default: ""
        },
        periodLabel: {
            string: String,
            default: ""
        },
        indexPrevious: {
            type: Number,
            default: 0
        },
        indexLast: {
            type: Number,
            default: 0
        },
        indexName: {
            type: String,
            default: ""
        }
    },
    computed: {
        percent: function () {
            return (this.last-this.previous)/this.previous*100;
        },
        percentIndex: function () {
            return (this.last-this.previous)/this.previous*100;
        },
        percentdiff: function () {
            const percent = (this.last-this.previous)/this.previous*100;
            const percentIndex = (this.indexLast-this.indexPrevious)/this.indexPrevious*100;
            return percent - percentIndex;
        },
        desc: function () {
            const percent = (this.last-this.previous)/this.previous*100;
            const percentIndex = (this.indexLast-this.indexPrevious)/this.indexPrevious*100;
            const percentDiff = percent - percentIndex;
            return `${percent>0?'👍 En hausse':'👎 En baisse'} de ${percent.toFixed(1)}% sur ${this.periodLabel}, ${percentDiff>0?'🚀 surperforme':'🐌 sousperforme'} l'index ${this.indexName} de ${percentDiff.toFixed(1)}%`
        }
    }
  }
</script>
<style>
.super i {
    position: absolute;
    font-size: 12px;
    padding: 3px;
    margin-top: -10px;
    margin-left: -4px;
}
.super {
    border-right: 2px solid gold;
}
.badge.custom {
    padding: 0.1rem .35rem;
}
.smalldot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 2px;
}
.smalldot.success {
    background-color: #00f2c3;
}
.smalldot.danger {
    background-color: #fd5d93;
}
</style>